import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { IAdminFooterIconSave, IAdminFooterIconSaveSideEnum } from 'api'
import { useNavigate } from 'react-router-dom'

export default function FooterIconEdit() {
  const id = useQueryValue('id', 0)
  const navigate = useNavigate()
  const isEdit = !!id

  const { data } = useApi({
    id: 'footerIconDetail',
    fn: api().adminFooterIcon.adminFooterIconDetail,
    params: id,
    enabled: isEdit,
  })

  const onSave = async (formData: {
    order: number
    side: string
    iconId: { id: number }
    krLink?: string
    enLink?: string
    zhLink?: string
    jpLink?: string
    thLink?: string
  }) => {
    try {
      const saveData: IAdminFooterIconSave = {
        order: formData.order,
        side: formData.side as IAdminFooterIconSaveSideEnum,
        iconId: formData.iconId.id,
        krLink: formData.krLink || null,
        enLink: formData.enLink || null,
        zhLink: formData.zhLink || null,
        jpLink: formData.jpLink || null,
        thLink: formData.thLink || null,
      }

      if (isEdit) {
        await api().adminFooterIcon.adminFooterIconUpdate(id, saveData)
      } else {
        await api().adminFooterIcon.adminFooterIconCreate(saveData)
      }
      navigate('/footer')
    } catch (error) {
      console.error(error)
      alert('저장 중 오류가 발생했습니다.')
    }
  }

  const onDelete = async () => {
    if (isEdit) {
      try {
        await api().adminFooterIcon.adminFooterIconDelete(id)
        navigate('/footer')
      } catch (error) {
        console.error('삭제 중 오류 발생:', error)
        alert('삭제 중 오류가 발생했습니다.')
      }
    }
  }

  return (
    <ContentDetailView
      data={
        data
          ? {
              order: data.order,
              side: data.side,
              iconId: { id: data.icon?.id || 0 },
              krLink: data.krLink || '',
              enLink: data.enLink || '',
              zhLink: data.zhLink || '',
              jpLink: data.jpLink || '',
              thLink: data.thLink || '',
            }
          : undefined
      }
      title={isEdit ? '푸터 아이콘 수정' : '푸터 아이콘 생성'}
      onSave={onSave}
      onDelete={isEdit ? onDelete : undefined}
    >
      <DetailForm
        data={data}
        fields={[
          {
            key: 'order',
            label: '순서',
            type: FormFieldType.NUMBER,
            required: true,
            default: data?.order || 0,
          },
          {
            key: 'side',
            label: '위치',
            type: FormFieldType.SELECT,
            required: true,
            default: data?.side || 'left',
            options: [
              { label: '왼쪽', value: 'left' },
              { label: '오른쪽', value: 'right' },
            ],
          },
          {
            key: 'iconId',
            label: '아이콘',
            type: FormFieldType.FILE,
            required: true,
            default: data?.icon?.id || undefined,
            async uploadHandler(file) {
              const res = await api().assets.uploadCreate({
                file: file.file,
                crop: JSON.stringify({ ...file.crop, highQuality: true }),
              })
              return res
            },
          },
          {
            key: 'krLink',
            label: '한국어 링크',
            type: FormFieldType.STRING,
            required: false,
            default: data?.krLink || '',
            placeholder: 'https://example.com',
          },
          {
            key: 'enLink',
            label: '영어 링크',
            type: FormFieldType.STRING,
            required: false,
            default: data?.enLink || '',
            placeholder: 'https://example.com',
          },
          {
            key: 'zhLink',
            label: '중국어 링크',
            type: FormFieldType.STRING,
            required: false,
            default: data?.zhLink || '',
            placeholder: 'https://example.com',
          },
          {
            key: 'jpLink',
            label: '일본어 링크',
            type: FormFieldType.STRING,
            required: false,
            default: data?.jpLink || '',
            placeholder: 'https://example.com',
          },
          {
            key: 'thLink',
            label: '태국어 링크',
            type: FormFieldType.STRING,
            required: false,
            default: data?.thLink || '',
            placeholder: 'https://example.com',
          },
        ]}
      />
    </ContentDetailView>
  )
}
